import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IcoCheck } from 'icone';
import { ContinuousReportingType } from '../ContinuousReporting';
import { format, isValid } from 'date-fns';

interface ContinuousReportingCheckCellProps {
	data: ContinuousReportingType;
	value: boolean;
	colDef: { field: string };
}

const ContinuousReportingCheckCell: React.FC<ContinuousReportingCheckCellProps> = ({ data, value, colDef: { field } }) => {
	if (!value) return;
	const text = (() => {
		switch (field) {
			case 'sent':
				return 'Inviato';
			case 'approved':
				return 'Approvato';
			default:
				return '';
		}
	})();
	const selectedDate = data[`${field}Date`];
	const formattedDate = selectedDate && isValid(new Date(selectedDate)) ? format(selectedDate, 'dd/MM/yyyy') : '';

	return (
		<OverlayTrigger placement="top" overlay={(props) => <Tooltip {...props}>{text}</Tooltip>}>
			{formattedDate ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						gap: '0.5rem',
					}}
				>
					<IcoCheck style={{ fill: '#689689' }} />
					<span style={{ marginTop: '1px' }}>{formattedDate}</span>
				</div>
			) : (
				<IcoCheck style={{ fill: '#689689' }} />
			)}
		</OverlayTrigger>
	);
};

export default ContinuousReportingCheckCell;
